import { useMediaQuery } from './useMediaQuery';

/**
 * Hook to detect tablet viewport (768px - 1024px)
 * @returns {boolean} - True if viewport is tablet size
 */
export const useIsTablet = () => {
    return useMediaQuery('(min-width: 768px) and (max-width: 1024px)');
};
